var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"modal-ostdataselector","size":"xl","visible":_vm.visible},on:{"hidden":_vm.hide,"ok":_vm.handleOk,"change":_vm.change}},[_c('card-fix-ost',{attrs:{"prodDate":_vm.prodDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }